<!--<p (click)="switchToBroadMatch()">Switch to broad match search</p>-->



// WEBPACK FOOTER //
// /app/src/app/components/fields/broad-match-toggle/broad-match-toggle.component.html